<template>
  <!-- <el-cascader
    ref="cascader"
    :value="value"
    :options="options"
    :disabled="disabled"
    :props="{multiple:true,checkStrictly:true}"
    filterable
    clearable
    separator="-"
    :placeholder="value.length > 0 || isEdit ? ' ' : placeholder"
    class="country-area-cascader"
    @input="val=>{$emit('input',val)}"
    @visible-change="onVisibleChange"
  /> -->
  <el-cascader
    ref="cascader"
    :value="value"
    :options="options"
    :disabled="disabled"
    :props="{multiple:true}"
    filterable
    clearable
    separator="-"
    :placeholder="value.length > 0 || isEdit ? ' ' : placeholder"
    class="country-area-cascader"
    @input="val=>{$emit('input',val)}"
    @visible-change="onVisibleChange"
  />
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'

export default {
  name: 'CountryAreaCascader',
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: ' ' }
  },
  data() {
    return {
      options: [],
      isEdit: false // 是否正在编辑
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    value() {
      this.toCustomDisplay()
    }
  },
  created() {
    const countryList = getCacheListByKey(TYPE_NAMES.basic_data_Country)
    const divisionList = getCacheListByKey(TYPE_NAMES.basic_data_AdministrativeDivision)

    const hasChildOptions = []
    const noChildOptions = []
    for (const country of countryList) {
      const countryOption = {
        value: country.code,
        label: this.isZh ? country.chineseName : country.name
      }
      const provinceList = divisionList.filter(p => p.parentId === country.uuid)
      if (provinceList.length > 0) {
        const countryChildren = []
        for (const province of provinceList) {
          const provinceOption = {
            value: province.code,
            label: this.isZh ? province.name : province.englishName
          }
          const cityList = divisionList.filter(p => p.parentId === province.uuid)
          if (cityList.length > 0) {
            const provinceChildren = []
            for (const city of cityList) {
              const cityOption = {
                value: city.code,
                label: this.isZh ? city.name : city.englishName
              }
              const districtList = divisionList.filter(p => p.parentId === city.uuid)
              if (districtList.length > 0) {
                const cityChildren = []
                for (const district of districtList) {
                  cityChildren.push({
                    value: district.code,
                    label: this.isZh ? district.name : district.englishName
                  })
                }
                cityOption.children = cityChildren
              }
              provinceChildren.push(cityOption)
            }
            provinceOption.children = provinceChildren
          }
          countryChildren.push(provinceOption)
        }
        countryOption.children = countryChildren
        hasChildOptions.push(countryOption)
      } else {
        noChildOptions.push(countryOption)
      }
    }
    this.options = [...hasChildOptions, ...noChildOptions]
  },
  mounted() {
    this.toCustomDisplay(false)
  },
  methods: {
    toCustomDisplay() {
      this.$nextTick(() => {
        const cascader = this.$refs.cascader
        if (!cascader) {
          return
        }
        const tags = cascader.$el.querySelector('.el-cascader__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let searchInput = null
        for (const child of tags.childNodes) {
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-cascader__search-input')) {
            searchInput = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (cascader.inputValue) {
            cascader.inputValue = cascader.inputValue.trim()
          }
          if (cascader.presentText) {
            cascader.presentText = cascader.presentText.trim()
          }
          if (searchInput) {
            searchInput.style.display = ''
            if (searchInput.value) {
              searchInput.value = searchInput.value.trim()
            }
            searchInput.setAttribute('placeholder', this.getDisplay() || this.placeholder)
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getDisplay()
          customDisplay.setAttribute('title', this.getDisplayTip())
          if (searchInput) {
            searchInput.style.display = 'none'
          }
        }
      })
    },
    getDisplay() {
      const texts = []
      for (const arr of this.value) {
        let option = this.options.find(p => p.value === arr[0])
        if (!option) {
          continue
        }
        let text = option.label
        for (let i = 1; i < arr.length; ++i) {
          if (!option.children) {
            break
          }
          option = option.children.find(p => p.value === arr[i])
          if (!option) {
            break
          }
          text += '-' + option.label
        }
        texts.push(text)
      }
      return texts.join(',')
    },
    getDisplayTip() {
      const texts = []
      for (const arr of this.value) {
        let option = this.options.find(p => p.value === arr[0])
        if (!option) {
          continue
        }
        let text = option.label
        for (let i = 1; i < arr.length; ++i) {
          if (!option.children) {
            break
          }
          option = option.children.find(p => p.value === arr[i])
          if (!option) {
            break
          }
          text += '-' + option.label
        }
        texts.push(text)
      }
      return texts.join('\n')
    },
    onVisibleChange(e) {
      this.isEdit = e
      this.toCustomDisplay()
    }
  }
}
</script>

<style lang="scss">
.el-cascader.country-area-cascader {
  width: 100%;
  .el-cascader__tags {
    .custom-display {
      overflow: hidden;
      white-space: nowrap;
      padding-left: 9px;
    }
    .el-tag--info {
      display: none;
    }
    .el-cascader__search-input {
      margin-left: 9px;
    }
  }
}
</style>
